import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICreatorData } from '../../interfaces/creator.interfaces';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreatorService {
  constructor(private http: HttpClient) {}

  getCreatorData(creatorId: string): Observable<ICreatorData> {
    const apiUrl = `${environment.apiBaseUrl}/d2c/creators/${creatorId}/profile`;
    return this.http.get<ICreatorData>(apiUrl);
  }
}
